import "../style/Filters.scss";
import React from "react";
import Select from "react-select";
import { normalizeOptions } from "@shared/First";


const Filter = ({ filters, filtersLoading, values, onChange, onReset, resetKey }) => {
  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: "35px",
      height: "auto",
      borderRadius: "6px",
      borderColor: state.isFocused ? "#C2185B" : "#ccc",
      boxShadow: state.isFocused ? "0 0 0 1px #C2185B" : "none",
      flexWrap: "wrap",
      alignItems: "center",
      padding: "0 8px",
    }),
    valueContainer: (base) => ({
      ...base,
      padding: 0,
      margin: 0,
      minHeight: "35px",
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
      lineHeight: "1",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "35px",
    }),
    multiValue: (base) => ({
      ...base,
      margin: "2px 4px 2px 0",
    }),
  };

  const source = (Array.isArray(filtersLoading) && filtersLoading.length > 0)
    ? filtersLoading
    : (Array.isArray(filters) ? filters : []);

  const sortedFilters = source.slice().sort((a, b) => {
    if (a.type === "select" || a.type === "input") {
      return a.label.localeCompare(b.label);
    }
    if (a.type === "range") {
      return a.label > b.label ? 1 : -1;
    }
    return 0;
  });

  const queryParams = new URLSearchParams(location.search);


  // активность считаем только по реальным фильтрам
  const filtersMeta = sortedFilters.map(f => ({ id: f.id, type: f.type }));

  const hasActiveFilters = filtersMeta.some(({ id, type }) => {
    const v = values?.[id];
    if (type === "select") return Array.isArray(v) && v.length > 0;
    if (type === "range") return Boolean(v?.from || v?.to);
    if (type === "checkbox") return v === true; // только true считаем активным
    return v != null && String(v).trim() !== "";
  });
  console.log('values', values);
  // отдельно проверяем поиск q
  const searchQuery = queryParams.get("q"); // или бери из useLocation, если он в query
  const hasSearch = searchQuery != null && String(searchQuery).trim() !== "";

  // объединяем
  const hasActive = hasActiveFilters || hasSearch;


  const handleResetFilters = () => {
    onReset?.();
  };

  return (
    <div className="filters">
      {hasActive && (
        <div className="filters-toolbar">
          <button
            type="button"
            className="reset-filters-btn"
            onClick={handleResetFilters}
            title="Сбросить все фильтры (кроме page и limit)"
          >
            Сбросить фильтры
          </button>
        </div>
      )}

      {sortedFilters.map((filter) => {
        if (filter.type === "input") {
          return (
            <div className="filter" key={filter.id}>
              <label>{filter.label}:</label>
              <input
                type="text"
                placeholder={filter.placeholder}
                value={values[filter.id] || ""}
                onChange={(e) => onChange(filter.id, e.target.value)}
              />
            </div>
          );
        }

        if (filter.type === "range") {
          return (
            <div className="filter filter--range" key={filter.id}>
              <label>{filter.label}:</label>
              <div className="range-inputs">
                <input
                  type="number"
                  placeholder={filter.placeholders[0]}
                  value={values[filter.id]?.from || ""}
                  onChange={(e) =>
                    onChange(filter.id, {
                      ...values[filter.id],
                      from: e.target.value,
                    })
                  }
                />
                <span className="range-separator">—</span>
                <input
                  type="number"
                  placeholder={filter.placeholders[1]}
                  value={values[filter.id]?.to || ""}
                  onChange={(e) =>
                    onChange(filter.id, {
                      ...values[filter.id],
                      to: e.target.value,
                    })
                  }
                />
              </div>
            </div>
          );
        }

        if (filter.type === "select") {
          const normalized = normalizeOptions(filter.label, filter.options);

          // Если options уже в правильной форме, просто передайте их напрямую
          const options = normalized.map((opt) =>
            typeof opt === 'object' ? opt : { value: opt, label: opt }
          );

          return (
            <div className="filter" key={filter.id}>
              <label>{filter.label}:</label>
              <Select
                key={`${filter.id}-${resetKey}`} // точечный «ремонт» селектов
                isMulti
                classNamePrefix="custom-select"
                isSearchable
                placeholder={filter.label}
                value={Array.isArray(values[filter.id]) ? values[filter.id] : []} // Убедитесь, что значение для Select массив
                options={options}
                onChange={(selected) => onChange(filter.id, selected)}
                styles={{
                  ...customSelectStyles,
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  menu: (base) => ({ ...base, zIndex: 9999 }),
                }}
                menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                menuPosition="fixed"
                menuShouldScrollIntoView={false}
                closeMenuOnScroll={false}
              />
            </div>
          );
        }


        if (filter.type === "checkbox") {
          return (
            <label className="filter filter--checkbox" key={filter.id}>
              <input
                type="checkbox"
                checked={Boolean(values[filter.id])}
                onChange={(e) => onChange(filter.id, e.target.checked)}
              />
              {filter.label}
            </label>
          );
        }

        return null;
      })}
    </div>
  );
};

export default Filter;
